/* GREENAPPLE K1 – Shop-Kopf (AE81, 02.11.2026): ab 80 px Scroll kompakt (Schatten, Logo 90 %, Höhe bleibt); Warenkorb-Zähler federt bei jeder Änderung. */
(() => {
  const kopf = document.querySelector('.section-header');
  if (kopf) {
    let geplant = false;
    const setzen = () => { kopf.classList.toggle('g24-kompakt', scrollY > 80); geplant = false; };
    addEventListener('scroll', () => { if (!geplant) { geplant = true; requestAnimationFrame(setzen); } }, { passive: true });
    setzen();
  }
  const korb = document.getElementById('cart-icon-bubble');
  if (!korb || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const zahl = () => { const b = korb.querySelector('.cart-count-bubble'); return b ? b.textContent.trim() : ''; };
  let alt = zahl();
  new MutationObserver(() => {
    const neu = zahl();
    if (neu === alt) return;
    alt = neu;
    const b = korb.querySelector('.cart-count-bubble');
    if (!b) return;
    b.classList.remove('springt'); void b.offsetWidth; b.classList.add('springt');
  }).observe(korb, { childList: true, subtree: true, characterData: true });
})();